import clsx from 'clsx';
import React from 'react';

export const SQUARE = 'square';
export const CIRCLE = 'circle';

type SkeletonProps = {
    className?: string;
    type: typeof SQUARE | typeof CIRCLE;
};

export const Skeleton = ({ className, type }: SkeletonProps) => {
    const sizeClassName = clsx(
        'animate-pulse bg-gray-100 dark:bg-icoDarkMode-deepBlack',
        {
            'rounded-md': type === 'square',
            'rounded-full ': type === 'circle'
        },
        className
    );
    return <div data-testid="skeleton" className={sizeClassName} />;
};
